"use client"

import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

// The load-more button writes its own bookkeeping into the address with
// replaceState. Those params never change what the server renders, and a refresh
// on them throws the loaded pages away and sends the shopper back to the top of
// the list, so they are left out of the comparison.
const CLIENT_ONLY_PARAMS = ["lp", "limit"];

/** The part of the query the server actually renders from. */
function serverQueryOf(searchParams: URLSearchParams) {
    const params = new URLSearchParams(searchParams);
    CLIENT_ONLY_PARAMS.forEach((name) => params.delete(name));
    return params.toString();
}

export default function PlpEquivalentPathQueryRefresh() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const previousSearchRef = useRef<string | null>(null);
    const search = serverQueryOf(searchParams);

    useEffect(() => {
        if (previousSearchRef.current === null) {
            previousSearchRef.current = search;
            return;
        }

        if (previousSearchRef.current === search) return;

        previousSearchRef.current = search;
        // Static equivalent-path pages do not read query params, so query-only navigation needs a fresh RSC payload.
        router.refresh();
    }, [router, search]);

    return null;
}
